// import { Component, Inject, Input } from "@angular/core";
// import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
// import { ToastrService } from "ngx-toastr";
// import { EvalService } from "../../eval.service";

// @Component({
//   selector: "vex-exit-code-fullscreen",
//   templateUrl: "./exit-code-fullscreen.component.html",
//   styleUrls: ["./exit-code-fullscreen.component.scss"],
// })
// export class ExitCodeFullscreenComponent {
//   code: string[] = ["", "", "", ""];
//   boxes = [0, 1, 2, 3];
//   isInvalidCode = false;
//   isLoading: boolean;
//   title: string;

//   constructor(
//     private dialogRef: MatDialogRef<ExitCodeFullscreenComponent>,
//     private toastr: ToastrService,
//     private service: EvalService,
//      @Inject(MAT_DIALOG_DATA) private data: any
//   ) {
//     this.title = data?.title || "Exit Code Verification";
//   }

//   // Handle code submission
//   submitCode() {
//     const enteredCode = this.code.join("");
//     if (!this.validateCodeFormat(enteredCode)) {
//       this.isInvalidCode = true;
//       this.toastr.error("Invalid code format. Please try again.", "Error");
//       return;
//     }

//     this.isLoading = true; // Start loading
//     this.service.checkExitCode({ exitCode: enteredCode }).subscribe({
//       next: (response) => {
//         this.isLoading = false; // Stop loading
//         if (response.success && response.exitCodeExists) {
//           this.dialogRef.close("success"); // Close the dialog on success
//         } else {
//           this.isInvalidCode = true;
//           this.toastr.error("Invalid code. Please try again.", "Error");
//         }
//       },
//       error: () => {
//         this.isLoading = false; // Stop loading on error
//         this.toastr.error(
//           "Something went wrong. Please try again later.",
//           "Error"
//         );
//       },
//     });
//   }

//   // Validate the entered code
//   validateCodeFormat(code: string): boolean {
//     return code.length === 4; // Ensure exactly 4 characters are entered
//   }

//   onCancel(): void {
//     this.dialogRef.close();
//   }

//   // Move to the next input box automatically
//   onInputChange(event: KeyboardEvent, index: number) {
//     const input = event.target as HTMLInputElement;
//     if (input.value && index < this.boxes.length - 1) {
//       const nextInput = document.querySelectorAll(".code-box")[
//         index + 1
//       ] as HTMLInputElement;
//       if (nextInput) {
//         nextInput.focus();
//       }
//     }
//   }
// }

import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { EvalService } from "../../eval.service";
import { AuthService } from "src/app/pages/auth/authServices";

@Component({
  selector: "vex-exit-code-fullscreen",
  templateUrl: "./exit-code-fullscreen.component.html",
  styleUrls: ["./exit-code-fullscreen.component.scss"],
})
export class ExitCodeFullscreenComponent implements OnInit, OnDestroy {
  code: string[] = ["", "", "", ""];
  boxes = [0, 1, 2, 3];
  isInvalidCode = false;
  isLoading = false;
  title = "Exit Code Verification";
  id: string;
  roleName: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private service: EvalService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Get roleName and log it
    this.roleName = this.authService.getRoleName();

    // Get id from query params
    this.id = this.route.snapshot.queryParamMap.get("id")!;

    this.route.queryParams.subscribe((params) => {
      const source = params["source"];
      this.title =
        source === "applicant"
          ? "For Applicant"
          : source === "interpreter"
          ? "For Interpreter"
          : source === "medical-assistant"
          ? "For Medical Assistant"
          : "Enter Exit Code";
      console.log(
        "ExitCodeFullscreenComponent - source:",
        source,
        "title:",
        this.title
      );
    });

    // Validate id
    if (!this.id) {
      console.error(
        "No id provided in query params, redirecting to /reports/oqme/evaluation"
      );
      this.toastr.error("Invalid encounter ID.", "Error");
      localStorage.removeItem("exitCodeActive");
      this.router.navigate(["exit-code"]);
      return;
    }

    // Prevent back navigation
    history.pushState(null, "", location.href);
    window.onpopstate = () => {
      console.log("popstate event triggered in ExitCodeFullscreenComponent");
      history.pushState(null, "", location.href);
    };

    // Redirect if user is not authorized
    if (
      this.roleName !== "MEDICAL ASSISTANT" &&
      this.roleName !== "MEDICAL ASSISTANT_MANAGER"
    ) {
      console.log(
        "Unauthorized role, redirecting to reports/oqme/evaluation?id=" +
          this.id
      );
      localStorage.removeItem("exitCodeActive");
      this.router.navigate(["exit-code"], { queryParams: { id: this.id } });
    } else {
      console.log("Authorized role, setting exitCodeActive");
      localStorage.setItem("exitCodeActive", "true");
    }
  }

  safeRemoveLocalStorage(keys: string[]) {
    keys.forEach((key) => {
      if (localStorage.getItem(key) !== null) {
        localStorage.removeItem(key);
      }
    });
  }

  submitCode(): void {
    const enteredCode = this.code.join("");
    if (!this.validateCodeFormat(enteredCode)) {
      this.isInvalidCode = true;
      this.toastr.error(
        "Invalid code format. Please enter a 4-digit code.",
        "Error"
      );
      return;
    }

    this.isLoading = true;

    this.service.checkExitCode({ exitCode: enteredCode }).subscribe({
      next: (response) => {
        this.safeRemoveLocalStorage([
          "applicantDialogOpen",
          "applicantDialogData",
          "interpreterDialogOpen",
          "interpreterDialogData",
          "vitalsDialogOpen",
          "vitalsDialogData",
        ]);
        this.isLoading = false;
        if (response.success && response.exitCodeExists) {
          console.log(
            "Code validated successfully, navigating to reports/oqme/evaluation?id=" +
              this.id
          );
          localStorage.removeItem("exitCodeActive");
          this.toastr.success("Code validated successfully.");
          this.router.navigate(["reports/oqme/evaluation"], {
            queryParams: { id: this.id, occurrenceId: this.route.snapshot.queryParamMap.get("occurrenceId") },
          });
        } else {
          this.isInvalidCode = true;
          this.toastr.error("Invalid code. Please try again.", "Error");
        }
      },
      error: (err) => {
        this.isLoading = false;
        const message =
          err?.error?.message ||
          "Something went wrong. Please try again later.";
        this.toastr.error(message, "Error");
      },
    });
  }

  validateCodeFormat(code: string): boolean {
    return code.length === 4 && /^\d{4}$/.test(code);
  }

  onCancel(): void {
    console.log(
      "Cancel clicked, navigating to reports/oqme/evaluation?id=" + this.id
    );
    localStorage.setItem("exitCodeActive", "true");
    this.router.navigate(["reports/oqme/evaluation"], {
      queryParams: { id: this.id, occurrenceId: this.route.snapshot.queryParamMap.get("occurrenceId") },
    });
  }

  onInputChange(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;
    if (input.value && index < this.boxes.length - 1) {
      const nextInput = document.querySelectorAll(".code-box")[
        index + 1
      ] as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  ngOnDestroy(): void {
    console.log("ExitCodeFullscreenComponent ngOnDestroy");
    window.onpopstate = null;
  }
}
